// extracted by mini-css-extract-plugin
module.exports = {"add":"styles_add__1yOXm","addInputWrapper":"styles_addInputWrapper__1q9wI"};